var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('NavBar'),_c('v-main',{staticStyle:{"background":"hwb(228 91% 7%)"}},[_c('router-view')],1),_c('FooTer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }